module.exports = __webpack_public_path__ + "img/my_archive.9c73c44d.svg";